export enum SessionDataType {
	GET_ACCOUNTS = '[Session] GET_ACCOUNTS',
	SET_ACCOUNTS = '[Session] SET_ACCOUNTS',
	START_GET_SESSIONS = '[Session] START_POLLING',
	PULL_SESSIONS = '[Session] PULL_SESSIONS',
	SET_SESSIONS = '[Session] SET_SESSIONS',
	STOP_GET_SESSIONS = '[Session] STOP_POLLING',
	GET_SESSION_BY_ID = '[Session] GET_BY_ID',
	SET_SESSION_BY_ID = '[Session] SET_BY_ID',
	REMOVE_SESSION = '[Session] REMOVE',
	SET_SESSION_NOTIFICATION = '[Session] SET_NOTIFICATION',
	CLEAR_SESSION_NOTIFICATION = '[Session] CLEAR_NOTIFICATION',
	SESSION_TICK = '[Session]SESSION_TICK',
	CLEAR_SELECTED_SESSION = '[Session] Clear Selected Session',
	SET_ACCOUNT_VIEWED = '[Session] Set Account Viewed',
}

export interface SessionsAction {
	readonly type: SessionDataType;
	readonly payload: any;
}

export interface SessionsData {
	list: SessionsItem[];
	currentAccounts: SessionAccounts;
	selected: SessionsItem;
	sessionNotification: SessionNotification;
}

export interface ViewedAccounts {
	[key: string]: boolean;
}

export interface SessionNotification {
	type: string;
	message: string;
	icon: string;
	randomId: number;
}

export interface SessionAccounts {
	primaryEmail: string;
	profilePk: number;
	firstName: string;
	statuses: string[];
	accounts: AccountItem[];
	viewed: ViewedAccounts[];
}

export type AccountStatuses =
	| 'Past Due'
	| 'Usage Exceeded'
	| 'Disabled'
	| 'Special Case'
	| 'Paused'
	| 'Deleted'
	| 'Expired'
	| 'Not Verified'
	| 'Removed';

export interface AccountItem {
	accountId: number;
	planType: string;
	primaryStatus: 'string';
	statuses: AccountStatuses[];
	accountStatusInfo: AccountStatusInfo;
	caspioUrl: string;
	accountName: string;
	accountFriendlyName: string;
	isOwner: boolean;
	isAccessDisabled: boolean;
	isAdministrator: boolean;
	isInCustomGroup: boolean;
}

interface AccountStatusInfo {
	disabledOnUtc: string;
	removedOnUtc: string;
	deletedOnUtc: string;
	expiredOnUtc: string;
	pausedOnUtc: string;
	setBy: string;
	usageExceededOnUtc: string;
	becomeActiveOnUtc: string;
	currentAttempts: number;
	lastSentOnUtc: string;
}

export enum SourceType {
	Phone = 'Phone',
	Chat = 'Chat',
	SupportTicket = 'SupportTicket',
	Share = 'Share',
	Unknown = 'Unknown',
	Accounts = 'Accounts',
	History = 'History',
	InternalApp = 'InternalApp',
}

export interface SessionsItem {
	sessionId: string;
	trackingNumber: string;
	expiresOnUtc: string;
	state: SessionState;
	lastUpdatedAtUtc: string;
	caspioIdNameValue: string;
	sessionSource: SourceType;
	expiresIn: number;
	sharedBy: string;
}

export enum SessionState {
	NOT_VERIFIED = 'NOT_VERIFIED',
	MAIN_FLOW_CONFIRM_EMAIL = 'MAIN_FLOW_CONFIRM_EMAIL',
	VERIFIED = 'VERIFIED',
	LOGGED_OUT = 'LOGGED_OUT',
	EMAIL_FLOW_SEND_PIN = 'EMAIL_FLOW_SEND_PIN',
	EMAIL_FLOW_VERIFY_PIN = 'EMAIL_FLOW_VERIFY_PIN',
	PERSONAL_DATA_FLOW_COMPLETE_EMAIL = 'PERSONAL_DATA_FLOW_COMPLETE_EMAIL',
	PERSONAL_DATA_FLOW_SEND_PIN = 'PERSONAL_DATA_FLOW_SEND_PIN',
	PERSONAL_DATA_FLOW_VERIFY_PIN = 'PERSONAL_DATA_FLOW_VERIFY_PIN',
	EMAIL_FLOW_CHOOSE_SOURCE = 'EMAIL_FLOW_CHOOSE_SOURCE',
	MAIN_FLOW_CHOOSE_SOURCE = 'MAIN_FLOW_CHOOSE_SOURCE',
	NEW_SHARED_SESSION = 'NEW_SHARED_SESSION',
}

export interface SessionAccounts {
	primaryEmail: string;
	statuses: string[];
	accounts: AccountItem[];
}

export interface AccountItem {
	planType: string;
	statuses: AccountStatuses[];
	isOwner: boolean;
}
